import React from 'react';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@emotion/react';

const useStyles = makeStyles()((theme) => {
    return {
        main: {
            background: theme?.palette?.primaryWhite?.main,
            "& .MuiInputBase-root": {
                borderRadius: "8px",
            },
            "& .MuiOutlinedInput-input": {
                // padding: "12.5px 14px",
            }
        },
    };
});

const CommonTextArea = ({ label, rows = 4, value, onChange, labelSize, valid, disabled, ...rest }) => {
    const { classes } = useStyles();
    const theme = useTheme()
    return (
        <>
            <Typography position="relative" sx={{ display: "inline-block", marginBottom: "4px", fontSize: labelSize || "14px", color: rest.disabled ? '#c0c1da' : theme?.palette?.primary?.main }}>
                {label}
                {valid && <span style={{ position: "absolute", right: -11, top: -4, color: "red" }}>*</span>}
            </Typography>
            <TextField
                className={`${classes?.main}`}
                multiline
                rows={rows}
                variant="outlined"
                value={value}
                onChange={onChange}
                fullWidth
                disabled={disabled}
                {...rest}
            />
        </>
    );
};

export default CommonTextArea;
